module.exports = __webpack_public_path__ + "static/ecommerce-53fa9681cfffec60970024818ddb18b2.png";